import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import {Prompt} from 'react-router-dom';

export default function ConfirmLeave(props) {
  const {message, when} = props;
  return <Prompt message={typeof message === 'string' ? I18n.t(message) : message} when={when} />;
}

ConfirmLeave.defaultProps = {
  message: 'common:notification.unsaved-changes',
  when: true,
};

ConfirmLeave.propTypes = {
  /** An i18n key for the message to display, or a function to execute that should return the message. If omitted, the default message will be displayed. */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Determines when this prompt should be enabled. */
  when: PropTypes.bool,
};
